import { IArticle8State } from './types';

const initialArticle8State = (): IArticle8State => ({
  loading: false,
  selectedSystem: undefined,
});

export default initialArticle8State;
